import { Formik } from 'formik'

import Column from '@components/column'
import { useEffect, useState } from 'react'
import { StyleRow, StyleSearchWrapper, StyleSelectedCardWrapper } from './style'
import SelectedMedicines from '@commons/medicineSearch/selectedItems'
import SearchMedicines from '@commons/medicineSearch/search'
import Button from '@components/button'
import { Appointment } from '@apis'
import { useSelector } from 'react-redux'
const Medicines = ({ canSave = true }) => {
  const { data: appointment } = useSelector(
    (state: any) => state.consultAppointment,
  )
  const [initialValues, setInitalValues] = useState({
    medicines: [],
  })
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values: any) => {
    setLoading(true)
    if (!!values?.medicines?.length) {
      await Appointment.update({
        data: {
          medicines: values?.medicines,
        },
        id: appointment?.id,
      }).catch(() => {})
    }

    setLoading(false)
  }

  useEffect(() => {
    if (appointment?.id) {
      setInitalValues({
        medicines: appointment?.infos?.medicines,
      })
    }
  }, [appointment?.id])
  return (
    <Column>
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
      >
        {({ handleSubmit, values, setFieldValue }) => {
          return (
            <Column rowGap={20}>
              <StyleRow>
                <StyleSelectedCardWrapper>
                  <SelectedMedicines
                    selectedItems={values?.medicines}
                    setFieldValue={setFieldValue}
                  />
                </StyleSelectedCardWrapper>
                <StyleSearchWrapper>
                  <SearchMedicines
                    selectedItems={values?.medicines}
                    setFieldValue={setFieldValue}
                  />
                </StyleSearchWrapper>
              </StyleRow>
              {!!canSave && (
                <Column alignItems="flex-end">
                  <Button
                    title="Save"
                    type="button"
                    loading={loading}
                    onClick={handleSubmit}
                  />
                </Column>
              )}
            </Column>
          )
        }}
      </Formik>
    </Column>
  )
}

export default Medicines
